<template>
    <div class="product-create">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.go(-1);">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">Create Product</div>
                    </div>

                    <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                        Product created successfully.
                    </div>

                    <div class="col-md-4">
                    </div>
                </div>
            </div>

            <hr />
        </div>

        <div class="container">
            <h3 class="section-title mt-5">Basic Details</h3>

             <form @submit.prevent="checkForm" action="#" method="post">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-is-error': $v.productData.name.$error }">
                            <label for="">Product name *</label>
                            <input class="form-control" v-model.trim="$v.productData.name.$model" type="text">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-is-error': $v.productData.price.$error }">
                            <label for="">Product price *</label>
                            <input class="form-control" v-model.trim="$v.productData.price.$model" type="number" step="0.1" min="0">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-is-error': $v.productData.description.$error }">
                            <label for="">Product description *</label>
                            <textarea class="form-control" v-model.trim="$v.productData.description.$model" name="description" id="description" cols="30" rows="10"></textarea>
                        </div>
                    </div>

                    
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.productData.valid.$error }">
                            <label for="">Valid *</label>
                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.productData.valid.$model" id="active" type="radio"
                                        name="status" value="1" required class="custom-control-input">
                                    <label class="" for="active">Active</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.productData.valid.$model" id="inactive" type="radio"
                                        name="status" value="0" required class="custom-control-input">
                                    <label class="" for="inactive">Inactive</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="form-group" :class="{ 'form-is-error': $v.productData.is_bat.$error }">
                            <label for="">Is BAT *</label>
                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.productData.is_bat.$model" id="yes" type="radio"
                                        name="is_bat" value="1" required class="custom-control-input">
                                    <label class="" for="yes">Yes</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.productData.is_bat.$model" id="no" type="radio"
                                        name="is_bat" value="0" required class="custom-control-input">
                                    <label class="" for="no">No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.productData.brand_id.$error }">
                            <label for="">Brand *</label>

                            <select class="custom-select form-control" v-model.trim="$v.productData.brand_id.$model"  name="program" id="program">
                                <option v-for="brand in brands" v-bind:key="brand.id" :value="brand.id">{{brand.name}}</option>
                            </select>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.productData.brand_id.required">Brand is required</div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.productData.range_id.$error }">
                            <label for="">Range *</label>

                            <select class="custom-select form-control" v-model.trim="$v.productData.range_id.$model"  name="program" id="program">
                                <option v-for="range in ranges" v-bind:key="range.id" :value="range.id">{{range.name}}</option>
                            </select>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.productData.range_id.required">Range is required</div>
                        </div>
                    </div>
                </div>

                <button class="mt-5 btn btn-ecdc btn-shadow">Create</button>

            </form>
            
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getBrands, getRanges, storeProduct } from '../api'
import Loader from './Loader.vue'
import { required } from 'vuelidate/lib/validators'

export default {
    components: {
        appLoader: Loader
    },
    data() {
        return {
            productData: {
                name: "",
                valid: 1,
                price: 0,
                description: "",
                brand_id: 1,
                range_id: 1,
                is_bat: 1
            },
            brands:[],
            ranges:[],
            isLoading: true,
            isError: false,
            isSuccess: false
        }
    },
    validations: {
        productData: {
            name: {
                required
            },
            valid: {
                required
            },
            price: {
                required
            },
            description: {
                required
            },
            brand_id: {
                required
            },
            range_id: {
                required
            },
            is_bat: {
                required
            }
        }
    },
    async mounted() {
        this.isLoading = false;
        await this.getRanges();
        await this.getBrands();
    },
    methods: {
        async getBrands() {

            try {
                const result = await getBrands();
                this.brands = result.data.data;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getRanges() {

            try {
                const result = await getRanges();
                this.ranges = result.data.data;
            }
            catch(err) { 
                alert(err.response.data.message);
            }
        },
        async checkForm() {
            
            const _this = this;

            this.$v.productData.$touch();

            if(this.$v.productData.$invalid) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() { 
                    
                    _this.isError = false;
                }, 2000);
            }
            else {

                this.isLoading = true;

                try {
                    await storeProduct(this.productData);

                    this.isSuccess = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() { 
                        
                        _this.isSuccess = false;
                        _this.$router.push({ name: "productsDetails" });
                    }, 2000);
                }
                catch(err) {
                    alert(err);
                }

                this.isLoading = false;
            }
        }
    }
}
</script>